var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "operations-data-page" },
    [
      _c(
        "el-row",
        {
          staticClass: "flex-wrap",
          attrs: { gutter: _vm.device === "mobile" ? 0 : 5, type: "flex" },
        },
        [
          _c(
            "el-col",
            { staticClass: "mb-5", attrs: { md: 24, lg: 24 } },
            [
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { shadow: "hover", "body-style": { padding: "10px" } },
                },
                [
                  _c(
                    "div",
                    { staticClass: "mb-20 flex flex-wrap align-center" },
                    [
                      _c("b", { staticClass: "mr-15" }, [
                        _c("span", { staticClass: "lin" }),
                        _vm._v("运营数据"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "hidden-sm-and-down",
                          attrs: { size: "small" },
                          on: { change: _vm.selDataType },
                          model: {
                            value: _vm.listQuery.sel_agent_level,
                            callback: function ($$v) {
                              _vm.$set(_vm.listQuery, "sel_agent_level", $$v)
                            },
                            expression: "listQuery.sel_agent_level",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "0" } }, [
                            _vm._v("全部"),
                          ]),
                          _vm._v(" "),
                          _vm.agentInfo.agent_level < 1
                            ? _c("el-radio-button", { attrs: { label: "1" } }, [
                                _vm._v("贴牌"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.agentInfo.agent_level < 2
                            ? _c("el-radio-button", { attrs: { label: "2" } }, [
                                _vm._v("合伙人"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.agentInfo.agent_level < 3
                            ? _c("el-radio-button", { attrs: { label: "3" } }, [
                                _vm._v("代理商"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.agentInfo.agent_level < 4
                            ? _c("el-radio-button", { attrs: { label: "4" } }, [
                                _vm._v("业务员"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.agentInfo.agent_level < 5
                            ? _c("el-radio-button", { attrs: { label: "5" } }, [
                                _vm._v("商家"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticClass: "ml-10",
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          size: "small",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { change: _vm.handleDateChange },
                        model: {
                          value: _vm.listQuery.date_range,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "date_range", $$v)
                          },
                          expression: "listQuery.date_range",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "fs-s2 text-gray",
                          attrs: {
                            to:
                              "/home/operateData?l=" +
                              _vm.listQuery.sel_agent_level,
                          },
                        },
                        [
                          _vm._v("更多"),
                          _c("i", {
                            staticClass: "el-icon-arrow-right el-icon--right",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "hidden-sm-and-up mb-10",
                      attrs: { size: "small" },
                      on: { change: _vm.selDataType },
                      model: {
                        value: _vm.listQuery.sel_agent_level,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "sel_agent_level", $$v)
                        },
                        expression: "listQuery.sel_agent_level",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "0" } }, [
                        _vm._v("全部"),
                      ]),
                      _vm._v(" "),
                      _vm.agentInfo.agent_level < 1
                        ? _c("el-radio-button", { attrs: { label: "1" } }, [
                            _vm._v("贴牌"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.agentInfo.agent_level < 2
                        ? _c("el-radio-button", { attrs: { label: "2" } }, [
                            _vm._v("合伙人"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.agentInfo.agent_level < 3
                        ? _c("el-radio-button", { attrs: { label: "3" } }, [
                            _vm._v("代理商"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.agentInfo.agent_level < 4
                        ? _c("el-radio-button", { attrs: { label: "4" } }, [
                            _vm._v("业务员"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.agentInfo.agent_level < 5
                        ? _c("el-radio-button", { attrs: { label: "5" } }, [
                            _vm._v("商家"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticClass: "hidden-sm-and-up mb-10",
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      size: "small",
                      "value-format": "yyyy-MM-dd",
                    },
                    on: { change: _vm.handleDateChange },
                    model: {
                      value: _vm.listQuery.date_range,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "date_range", $$v)
                      },
                      expression: "listQuery.date_range",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.list
                          .filter(function (item) {
                            return parseFloat(item.order_total_amount) > 0
                          })
                          .sort(function (a, b) {
                            return (
                              parseFloat(b.order_total_amount) -
                              parseFloat(a.order_total_amount)
                            )
                          }),
                        stripe: "",
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "名称", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.name
                                        ? scope.row.name
                                        : scope.row.nick_name
                                    ) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "角色", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.role_name) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "总交易额", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.order_total_amount) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "总订单数", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.order_total_num) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "总商户", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.store_num) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "已铺货底座", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.devoted_zuo_num) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }